import { Button } from '@/components/_untitled/base/buttons/button';

import { prefixes, useTypedTranslation } from "@/locales";

interface StepFooterAction {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    loading?: boolean;
}

interface StepFooterProps {
    primary: StepFooterAction;
    back?: {
        show: boolean;
        onClick?: () => void;
    };
    secondary?: StepFooterAction;
}

export function StepFooter({ primary, back, secondary }: StepFooterProps) {
    const [tGeneral] = useTypedTranslation(prefixes('general'));

    return (
        <div className="flex gap-3 py-6 border-t border-secondary">
            { back?.show && (
                <Button onClick={ back.onClick } color="secondary">
                    { tGeneral('back') }
                </Button>
            ) }
            { secondary && (
                <Button
                    onClick={ secondary.onClick }
                    isDisabled={ secondary.disabled }
                    isLoading={ secondary.loading }
                    color="secondary"
                >
                    { secondary.label }
                </Button>
            ) }
            <Button
                onClick={ primary.onClick }
                isDisabled={ primary.disabled }
                isLoading={ primary.loading }
                className="flex-1"
            >
                { primary.label }
            </Button>
        </div>
    );
}
